// Priority countries we want at the top
const priorityCountries = [
  "United States",
  "Australia",
  "Canada",
  "Germany",
  "India",
  "Japan",
  "Singapore",
  "United Kingdom"
];

let ignoreNextCartUpdate = false;
let lastShippingSnapshot = null;
let shippingRatesVisible = false;
const QUOTE_CUSTOMER_API_BASE = "https://shopifywebhookserver.xyz/quote-customers";
const QUOTE_CUSTOMER_STORAGE_KEY = "quoteCustomerRecord";
const TARGET_BASE_PREFIX = "materials-characterization-analytical-services";
const TARGET_COLLECTION_HANDLES = new Set([
  "mse-analytical-services",
  TARGET_BASE_PREFIX,
  `${TARGET_BASE_PREFIX}-best-value`
]);

const COUNTRY_OPTIONS = [
  ["AF", "Afghanistan"], ["AL", "Albania"], ["DZ", "Algeria"], ["AD", "Andorra"], ["AO", "Angola"],
  ["AG", "Antigua and Barbuda"], ["AR", "Argentina"], ["AM", "Armenia"], ["AU", "Australia"], ["AT", "Austria"],
  ["AZ", "Azerbaijan"], ["BS", "Bahamas"], ["BH", "Bahrain"], ["BD", "Bangladesh"], ["BB", "Barbados"],
  ["BY", "Belarus"], ["BE", "Belgium"], ["BZ", "Belize"], ["BJ", "Benin"], ["BT", "Bhutan"],
  ["BO", "Bolivia"], ["BA", "Bosnia and Herzegovina"], ["BW", "Botswana"], ["BR", "Brazil"], ["BN", "Brunei"],
  ["BG", "Bulgaria"], ["BF", "Burkina Faso"], ["BI", "Burundi"], ["CV", "Cabo Verde"], ["KH", "Cambodia"],
  ["CM", "Cameroon"], ["CA", "Canada"], ["CF", "Central African Republic"], ["TD", "Chad"], ["CL", "Chile"],
  ["CN", "China"], ["CO", "Colombia"], ["KM", "Comoros"], ["CG", "Congo"], ["CD", "Congo (DRC)"],
  ["CR", "Costa Rica"], ["CI", "Cote d'Ivoire"], ["HR", "Croatia"], ["CU", "Cuba"], ["CY", "Cyprus"],
  ["CZ", "Czech Republic"], ["DK", "Denmark"], ["DJ", "Djibouti"], ["DM", "Dominica"], ["DO", "Dominican Republic"],
  ["EC", "Ecuador"], ["EG", "Egypt"], ["SV", "El Salvador"], ["GQ", "Equatorial Guinea"], ["ER", "Eritrea"],
  ["EE", "Estonia"], ["SZ", "Eswatini"], ["ET", "Ethiopia"], ["FJ", "Fiji"], ["FI", "Finland"],
  ["FR", "France"], ["GA", "Gabon"], ["GM", "Gambia"], ["GE", "Georgia"], ["DE", "Germany"],
  ["GH", "Ghana"], ["GR", "Greece"], ["GD", "Grenada"], ["GT", "Guatemala"], ["GN", "Guinea"],
  ["GW", "Guinea-Bissau"], ["GY", "Guyana"], ["HT", "Haiti"], ["HN", "Honduras"], ["HU", "Hungary"],
  ["IS", "Iceland"], ["IN", "India"], ["ID", "Indonesia"], ["IR", "Iran"], ["IQ", "Iraq"],
  ["IE", "Ireland"], ["IL", "Israel"], ["IT", "Italy"], ["JM", "Jamaica"], ["JP", "Japan"],
  ["JO", "Jordan"], ["KZ", "Kazakhstan"], ["KE", "Kenya"], ["KI", "Kiribati"], ["KW", "Kuwait"],
  ["KG", "Kyrgyzstan"], ["LA", "Laos"], ["LV", "Latvia"], ["LB", "Lebanon"], ["LS", "Lesotho"],
  ["LR", "Liberia"], ["LY", "Libya"], ["LI", "Liechtenstein"], ["LT", "Lithuania"], ["LU", "Luxembourg"],
  ["MG", "Madagascar"], ["MW", "Malawi"], ["MY", "Malaysia"], ["MV", "Maldives"], ["ML", "Mali"],
  ["MT", "Malta"], ["MH", "Marshall Islands"], ["MR", "Mauritania"], ["MU", "Mauritius"], ["MX", "Mexico"],
  ["FM", "Micronesia"], ["MD", "Moldova"], ["MC", "Monaco"], ["MN", "Mongolia"], ["ME", "Montenegro"],
  ["MA", "Morocco"], ["MZ", "Mozambique"], ["MM", "Myanmar"], ["NA", "Namibia"], ["NR", "Nauru"],
  ["NP", "Nepal"], ["NL", "Netherlands"], ["NZ", "New Zealand"], ["NI", "Nicaragua"], ["NE", "Niger"],
  ["NG", "Nigeria"], ["KP", "North Korea"], ["MK", "North Macedonia"], ["NO", "Norway"], ["OM", "Oman"],
  ["PK", "Pakistan"], ["PW", "Palau"], ["PS", "Palestine"], ["PA", "Panama"], ["PG", "Papua New Guinea"],
  ["PY", "Paraguay"], ["PE", "Peru"], ["PH", "Philippines"], ["PL", "Poland"], ["PT", "Portugal"],
  ["QA", "Qatar"], ["RO", "Romania"], ["RU", "Russia"], ["RW", "Rwanda"], ["KN", "Saint Kitts and Nevis"],
  ["LC", "Saint Lucia"], ["VC", "Saint Vincent and the Grenadines"], ["WS", "Samoa"], ["SM", "San Marino"], ["ST", "Sao Tome and Principe"],
  ["SA", "Saudi Arabia"], ["SN", "Senegal"], ["RS", "Serbia"], ["SC", "Seychelles"], ["SL", "Sierra Leone"],
  ["SG", "Singapore"], ["SK", "Slovakia"], ["SI", "Slovenia"], ["SB", "Solomon Islands"], ["SO", "Somalia"],
  ["ZA", "South Africa"], ["KR", "South Korea"], ["SS", "South Sudan"], ["ES", "Spain"], ["LK", "Sri Lanka"],
  ["SD", "Sudan"], ["SR", "Suriname"], ["SE", "Sweden"], ["CH", "Switzerland"], ["SY", "Syria"],
  ["TW", "Taiwan"], ["TJ", "Tajikistan"], ["TZ", "Tanzania"], ["TH", "Thailand"], ["TL", "Timor-Leste"],
  ["TG", "Togo"], ["TO", "Tonga"], ["TT", "Trinidad and Tobago"], ["TN", "Tunisia"], ["TR", "Turkey"],
  ["TM", "Turkmenistan"], ["TV", "Tuvalu"], ["UG", "Uganda"], ["UA", "Ukraine"], ["AE", "United Arab Emirates"],
  ["GB", "United Kingdom"], ["US", "United States"], ["UY", "Uruguay"], ["UZ", "Uzbekistan"], ["VU", "Vanuatu"],
  ["VA", "Vatican City"], ["VE", "Venezuela"], ["VN", "Vietnam"], ["YE", "Yemen"], ["ZM", "Zambia"], ["ZW", "Zimbabwe"]
];

function buildCountryOptions() {
  return COUNTRY_OPTIONS.map(([cca2, common]) => ({
    cca2,
    name: { common }
  }));
}

function populateCountrySelect(data) {
  const select = document.getElementById("country-select");
  if (!select) return false;

  const countries = Array.isArray(data) ? data.filter(country =>
    country &&
    typeof country.cca2 === "string" &&
    country.name &&
    typeof country.name.common === "string"
  ) : [];

  if (!countries.length) return false;

  select.innerHTML = "";

  const defaultOption = document.createElement("option");
  defaultOption.value = "";
  defaultOption.textContent = "Select";
  defaultOption.disabled = true;
  defaultOption.selected = true;
  select.appendChild(defaultOption);

  const sortedCountries = countries.sort((a, b) =>
    a.name.common.localeCompare(b.name.common)
  );

  priorityCountries.forEach(prioName => {
    const match = sortedCountries.find(
      c => c.name.common.toLowerCase() === prioName.toLowerCase()
    );
    if (match) {
      const option = document.createElement("option");
      option.value = match.cca2.toLowerCase();
      option.textContent = match.name.common;
      select.appendChild(option);
    }
  });

  const separator = document.createElement("option");
  separator.disabled = true;
  separator.textContent = "----------";
  select.appendChild(separator);

  sortedCountries.forEach(country => {
    if (!priorityCountries.some(
      p => p.toLowerCase() === country.name.common.toLowerCase()
    )) {
      const option = document.createElement("option");
      option.value = country.cca2.toLowerCase();
      option.textContent = country.name.common;
      select.appendChild(option);
    }
  });

  console.assert(select.options.length > 1, "Country dropdown should not be empty");
  return true;
}

function whenCountrySelectReady(callback) {
  let ran = false;

  const run = () => {
    if (ran) return;
    const select = document.getElementById("country-select");
    if (!select) return;
    ran = true;
    callback(select);
  };

  run();
  if (ran) return;

  document.addEventListener("DOMContentLoaded", run, { once: true });
  window.addEventListener("load", run, { once: true });
  setTimeout(run, 0);
}

function initializeCountrySelect() {
  whenCountrySelectReady(() => {
    const localCountries = buildCountryOptions();
    if (populateCountrySelect(localCountries)) {
      initAutocomplete();
      return;
    }
  });
}

initializeCountrySelect();

// Track address changes BUT don't reset on country change
// TODO reset taxes and shipping if address changes
function trackAddressChanges() {
  const fields = document.querySelectorAll(
    "#quote-address, #quote-city, #quote-state, #quote-zip, #quote-suite-number"
  );

  fields.forEach((field) => {
    field.addEventListener("input", () => {
      if (!shippingRatesVisible) return; // don't reset if rates not visible
      console.log("Address changed. Resetting shipping rates.");
      resetShippingRates();
    });
  });
}

/* ponytail: kept old remote country fetch disabled; native Intl path above now owns the dropdown.
// Fetch countries and build dropdown
fetch("https://restcountries.com/v3/all?fields=cca2,name")
  .then(res => res.json())
  .then(data => {
    const select = document.getElementById("country-select");
    if (!select) return;

    select.innerHTML = "";

    // Default placeholder
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = "Select";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    select.appendChild(defaultOption);

    // Sort API countries alphabetically
    const sortedCountries = data.sort((a, b) => 
      a.name.common.localeCompare(b.name.common)
    );

    // Add PRIORITY COUNTRIES first
    priorityCountries.forEach(prioName => {
      const match = sortedCountries.find(
        c => c.name.common.toLowerCase() === prioName.toLowerCase()
      );
      if (match) {
        const option = document.createElement("option");
        option.value = match.cca2?.toLowerCase() || "";
        option.textContent = match.name.common;
        select.appendChild(option);
      }
    });

    // Add separator line
    const separator = document.createElement("option");
    separator.disabled = true;
    separator.textContent = "──────────";
    select.appendChild(separator);

    // Add the rest of the countries, excluding the ones already highlighted
    sortedCountries.forEach(country => {
      if (!priorityCountries.some(
        p => p.toLowerCase() === country.name.common.toLowerCase()
      )) {
        const option = document.createElement("option");
        option.value = country.cca2?.toLowerCase() || "";
        option.textContent = country.name.common;
        select.appendChild(option);
      }
    });

    // Init autocomplete AFTER we populate
    initAutocomplete();
  })
  .catch(err => console.error(err));

*/
let autocomplete;

// Move handleAddressOrContactChange to global scope
function handleAddressOrContactChange({ resetAddressFields = false } = {}) {
  // If triggered by country change → reset fields
  if (resetAddressFields) {
    document.getElementById("quote-city").value = "";
    document.getElementById("quote-state").value = "";
    document.getElementById("quote-zip").value = "";
    document.getElementById("quote-address").value = "";
  }

  setupShippingButtonValidation();
  resetShippingRates();
  console.log("Shipping Rates Fired.")
}

// Initialize Google Places Autocomplete with safe restrictions
function initAutocomplete() {
  const input = document.getElementById("quote-address");
  const countrySelect = document.getElementById("country-select");
  if (!input || !countrySelect) return;

  // Safety check for Google Maps API
  if (typeof google === 'undefined' || !google.maps || !google.maps.places) {
    console.error('Google Maps API not loaded properly');
    return;
  }

  if (autocomplete) {
    autocomplete.setOptions({
      componentRestrictions: { country: countrySelect.value?.trim().toUpperCase() || "US" }
    });
    return;
  }

  const getCountryRestriction = () => {
    const val = countrySelect.value?.trim().toUpperCase();
    return val || "US";
  };

  autocomplete = new google.maps.places.Autocomplete(input, {
    types: ["address"],
    componentRestrictions: { country: getCountryRestriction() },
    fields: ["address_components", "geometry"]
  });

  countrySelect.addEventListener("change", () => {
    autocomplete.setOptions({
      componentRestrictions: { country: getCountryRestriction() }
    });

    // Country change resets dependent fields
    handleAddressOrContactChange({ resetAddressFields: true });
  });

  ["quote-email", "quote-address", "quote-city", "quote-state", "quote-zip"].forEach(id => {
    const field = document.getElementById(id);
    if (field) {
      field.addEventListener("input", () => handleAddressOrContactChange());
    }
  });

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    if (!place.address_components) return;

    const getComponent = (type, short = false) =>
      place.address_components.find(c => c.types.includes(type))?.[short ? "short_name" : "long_name"] || "";

    document.getElementById("quote-state").value = getComponent("administrative_area_level_1", true);
    document.getElementById("quote-city").value = getComponent("locality");
    document.getElementById("quote-zip").value = getComponent("postal_code");

    setupShippingButtonValidation();

    ['quote-city', 'quote-state', 'quote-zip'].forEach(id => {
      const field = document.getElementById(id);
      if (field) toggleFieldHighlight(field);
    });

    closeAllGooglePredictionDropdowns();
  });

  function closeAllGooglePredictionDropdowns() {
    const pacContainers = document.querySelectorAll('.pac-container');
    pacContainers.forEach(container => {
      container.style.display = 'none';
    });
  }
}

  // Track address changes BUT don’t reset on country change
  function trackAddressChanges() {
    const fields = document.querySelectorAll(
      "#quote-address, #quote-city, #quote-state, #quote-zip, #quote-suite-number"
    );

    fields.forEach((field) => {
      field.addEventListener("input", () => {
        if (!shippingRatesVisible) return; // don’t reset if rates not visible
        console.log("Address changed. Resetting shipping rates.");
        resetShippingRates();
      });
    });
  }

  // Shipping button validation stays same
  function validateShippingButton() {
    const address = document.getElementById("quote-address").value.trim();
    const company = document.getElementById("quote-company").value.trim();
    const city = document.getElementById("quote-city").value.trim();
    const state = document.getElementById("quote-state").value.trim();
    const zip = document.getElementById("quote-zip").value.trim();
    const email = document.getElementById("quote-email").value.trim();
    const firstName = document.getElementById("quote-first-name").value.trim();
    const lastName = document.getElementById("quote-last-name").value.trim();
    const procurementStatus = document.getElementById("quote-procurement-status").value.trim();

    const button = document.getElementById("quote-shipping-button");
    const isValid = address && city && state && zip && email && firstName && lastName && procurementStatus;

    button.classList.toggle("disabled", !isValid);
    button.setAttribute("tabindex", isValid ? "0" : "-1");
    button.setAttribute("aria-disabled", isValid ? "false" : "true");
    button.disabled = !isValid;

    if (isValid) button.classList.add("quote-address-available");
    else button.classList.remove("quote-address-available");
  }

  function setupShippingButtonValidation() {
    ["quote-address", "quote-city", "quote-state", "quote-zip", "quote-email", "quote-first-name", "quote-last-name", "quote-company"].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.addEventListener("input", validateShippingButton);
    });
    const procurementEl = document.getElementById("quote-procurement-status");
    if (procurementEl) procurementEl.addEventListener("change", validateShippingButton);
    validateShippingButton();
  }

async function fetchShippingRates() {
    const address = getCurrentAddressState();

    if (!address || !address.city || !address.state || !address.country || !address.zip) {
      alert("Please complete the address to calculate shipping.");
      return [];
    }

    await syncQuoteCartToShopifyCart();

    const payload = {
      shipping_address: {
        zip: address.zip,
        country: address.country.toUpperCase(),
        province: address.state
      }
    };

    // Original ASM shipping fetch
    const res = await fetch("/cart/shipping_rates.json", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    const mapped = (data?.shipping_rates || []).map(rate => {
      const formattedPrice = `$${parseFloat(rate.price).toFixed(2)}`;

      const deliveryText = Array.isArray(rate.delivery_range) && rate.delivery_range.length
        ? ` (${rate.delivery_range.join(" - ")})`
        : "";

      return {
        id: rate.code || rate.name,
        label: `${rate.name}${deliveryText}`,
        price: formattedPrice
      };
    });

    // Call proxy to calculate taxes
    const cart = JSON.parse(sessionStorage.getItem("quoteCart") || "[]");
    const savedProducts = cart.map(item => ({
      variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
      quantity: item.quantity
    }));

    const proxyPayload = {
      savedProducts,
      city: address.city,
      state: address.state,
      country: address.country.toUpperCase(),
      zip: address.zip
    };

    try {
      const proxyRes = await fetch("/apps/proxy", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(proxyPayload)
      });

      if (!proxyRes.ok) throw new Error(`Proxy error: HTTP ${proxyRes.status}`);

      const proxyData = await proxyRes.json();

      const calculated = proxyData?.data?.draftOrderCalculate?.calculatedDraftOrder;
      if (calculated) {
        const totalTaxSet = calculated.totalTaxSet?.presentmentMoney || {};
        const taxLines = (calculated.taxLines || []).map(line => ({
          title: line.title,
          rate: line.ratePercentage,
          amount: line.priceSet?.shopMoney?.amount || "0.00"
        }));

        const quoteTax = {
          amount: totalTaxSet.amount || "0.00",
          currency: totalTaxSet.currencyCode || "USD",
          lines: taxLines
        };

        // Save tax info for fetchShippingAndTax()
        localStorage.setItem("quoteTax", JSON.stringify(quoteTax));
        window.dispatchEvent(new Event("quoteCartUpdated"));
      } else {
        console.warn("Proxy returned no calculatedDraftOrder for taxes.");
      }
    } catch (err) {
      console.error("Failed to fetch proxy:", err);
    }

    await fetch("/cart/clear.js", { method: "POST" });

    // If no shipping rates found, add fallback option
    if (!mapped.length) {
      console.warn("No shipping rates returned. Adding fallback option.");

      const fallbackRate = {
        id: "pending-quote",
        label: "Additional Information Needed for Shipping Quote",
        price: ""
      };

      sessionStorage.setItem("selectedShippingOption", fallbackRate.label);
      sessionStorage.setItem("selectedShippingRate", "0");

      return [fallbackRate];
    }

    return mapped;
  }

function getEmailMarketingOptIn() {
    return Boolean(document.getElementById("quote-email-marketing")?.checked);
  }

  function getStoredQuoteCustomerRecord() {
    try {
      return JSON.parse(sessionStorage.getItem(QUOTE_CUSTOMER_STORAGE_KEY) || "{}");
    } catch (error) {
      console.error("Failed to parse quote customer record:", error);
      return {};
    }
  }

  function setStoredQuoteCustomerRecord(record) {
    sessionStorage.setItem(QUOTE_CUSTOMER_STORAGE_KEY, JSON.stringify(record || {}));
  }

  function normalizeQuoteEmail(email) {
    return String(email || "").trim().toLowerCase();
  }

  function isValidQuoteEmail(email) {
    const value = normalizeQuoteEmail(email);
    if (!value) return false;

    const probe = document.createElement("input");
    probe.type = "email";
    probe.required = true;
    probe.value = value;
    return probe.checkValidity();
  }

  async function startQuoteCustomerEmailSync() {
    const email = normalizeQuoteEmail(document.getElementById("quote-email")?.value);
    if (!isValidQuoteEmail(email)) return null;

    const emailMarketingOptIn = getEmailMarketingOptIn();
    const storedRecord = getStoredQuoteCustomerRecord();

    if (
      storedRecord.email === email &&
      storedRecord.emailMarketingOptIn === emailMarketingOptIn &&
      storedRecord.customerId
    ) {
      return storedRecord;
    }

    const response = await fetch(`${QUOTE_CUSTOMER_API_BASE}/email/start`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email,
        emailMarketingOptIn
      })
    });

    if (!response.ok) {
      throw new Error(`Email start failed: HTTP ${response.status}`);
    }

    const data = await response.json();
    if (!data?.ok || !data?.customer?.id) {
      throw new Error(data?.error || "Email start failed");
    }

    const record = {
      customerId: data.customer.id,
      email,
      emailMarketingOptIn,
      marketingState: data.customer.marketingState || ""
    };

    setStoredQuoteCustomerRecord(record);
    return record;
  }

  async function enrichQuoteCustomer() {
    const customerInfo = getCustomerInfo();
    const storedRecord = getStoredQuoteCustomerRecord();
    const response = await fetch(`${QUOTE_CUSTOMER_API_BASE}/customer/enrich`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: storedRecord.customerId || "",
        email: customerInfo.email,
        emailMarketingOptIn: customerInfo.emailMarketingOptIn,
        firstName: customerInfo.firstName,
        lastName: customerInfo.lastName,
        company: customerInfo.company,
        procurementStatus: customerInfo.procurementStatus,
        address1: customerInfo.address,
        address2: customerInfo.suite,
        city: customerInfo.city,
        state: customerInfo.state,
        zip: customerInfo.zip,
        country: customerInfo.country
      })
    });

    if (!response.ok) {
      throw new Error(`Customer enrich failed: HTTP ${response.status}`);
    }

    const data = await response.json();
    if (!data?.ok || !data?.customerId) {
      throw new Error(data?.error || "Customer enrich failed");
    }

    setStoredQuoteCustomerRecord({
      ...storedRecord,
      customerId: data.customerId,
      email: normalizeQuoteEmail(customerInfo.email),
      emailMarketingOptIn: customerInfo.emailMarketingOptIn
    });

    return data;
  }

  async function syncQuoteCustomerMarketing() {
    const customerInfo = getCustomerInfo();
    const storedRecord = getStoredQuoteCustomerRecord();

    if (!storedRecord.customerId && !isValidQuoteEmail(customerInfo.email)) {
      return null;
    }

    const response = await fetch(`${QUOTE_CUSTOMER_API_BASE}/customer/marketing`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerId: storedRecord.customerId || "",
        email: customerInfo.email,
        emailMarketingOptIn: customerInfo.emailMarketingOptIn
      })
    });

    if (!response.ok) {
      throw new Error(`Customer marketing sync failed: HTTP ${response.status}`);
    }

    const data = await response.json();
    if (!data?.ok || !data?.customer?.id) {
      throw new Error(data?.error || "Customer marketing sync failed");
    }

    setStoredQuoteCustomerRecord({
      ...storedRecord,
      customerId: data.customer.id,
      email: normalizeQuoteEmail(customerInfo.email),
      emailMarketingOptIn: customerInfo.emailMarketingOptIn,
      marketingState: data.customer.marketingState || ""
    });

    return data;
  }

function getCustomerInfo() {
    return {
      email: document.getElementById("quote-email")?.value.trim() || "",
      firstName: document.getElementById("quote-first-name")?.value.trim() || "",
      lastName: document.getElementById("quote-last-name")?.value.trim() || "",
      company: document.getElementById("quote-company")?.value.trim() || "",
      procurementStatus: document.getElementById("quote-procurement-status")?.value?.trim() || "",
      city: document.getElementById("quote-city")?.value.trim() || "",
      state: document.getElementById("quote-state")?.value.trim() || "",
      zip: document.getElementById("quote-zip")?.value.trim() || "",
      address: document.getElementById("quote-address")?.value.trim() || "",
      suite: document.getElementById("quote-suite-number")?.value.trim() || "",
      country: document.getElementById("country-select")?.value?.trim() || "",
      emailMarketingOptIn: getEmailMarketingOptIn()
    };
  }

  function normalizeCollectionHandles(handles = []) {
    return [...new Set(
      (Array.isArray(handles) ? handles : [])
        .filter(Boolean)
        .map(handle => String(handle).trim().toLowerCase())
        .filter(Boolean)
    )];
  }

  function normalizeProductType(value) {
    return String(value || "").trim();
  }

  function collectProductTypes(products = []) {
    return [...new Set(
      (Array.isArray(products) ? products : [])
        .map(product => normalizeProductType(product.product_type))
        .filter(Boolean)
    )];
  }

  document.getElementById("quote-shipping-button").addEventListener("click", (e) => {
    const btn = e.currentTarget;
    const isDisabled =
      btn.classList.contains("disabled") ||
      btn.getAttribute("aria-disabled") === "true";
    if (isDisabled) return;

    // Capture & save customer info before fetching rates
    const customerInfo = getCustomerInfo();
    sessionStorage.setItem("quoteCustomerInfo", JSON.stringify(customerInfo));
    // console.log("Saved customer info:", customerInfo);

    const cart = sessionStorage.getItem("quoteCart");
    const address = getCurrentAddressState();
    lastShippingSnapshot = { cart, address };

    btn.disabled = true;
    btn.setAttribute("aria-disabled", "true");
    btn.innerHTML = `
    <span class="loader-spinner"></span>
    <span class="loading-text">Calculating...</span>
  `;
    btn.classList.add("loading");

    fetchShippingRates()
      .then(rates => {
        if (!rates.length) {
          alert("No shipping options for this address.");
          return;
        }
        renderShippingRates(rates);
        document.getElementById("shipping-methods-container").classList.remove("dimmed", "hidden");
        document.getElementById("submit-quote")?.classList.remove("hidden");
        // document.getElementById("submit-quote")?.classList.add("submit-quote-available");
        const warning = document.getElementById('shipping-warning');
        if (warning) {
          warning.classList.remove("hidden");
        }
        shippingRatesVisible = true;
      })
      .catch(err => {
        console.error("Error fetching shipping rates:", err);
      })
      .finally(() => {
        btn.disabled = false;
        btn.setAttribute("aria-disabled", "false");
        btn.innerHTML = "Get Shipping Rates";
        btn.classList.remove("loading");
      });
  });

  function renderShippingRates(rates) {
    const container = document.getElementById("shipping-methods-container");
    container.innerHTML = "";

    rates.forEach(rate => {
      const option = document.createElement("div");
      option.className = "shipping-rate-option";
      option.innerHTML = `
      <label>
        <input type="radio" name="shipping_rate" value="${rate.id}" data-price="${parseFloat(
        rate.price.replace(/[^\d.]/g, "")
      )}" />
        <span class="label-text">
          <span class="label-title">${rate.label}</span>
          <span class="label-price">${rate.price}</span>
        </span>
      </label>
    `;

      const radio = option.querySelector('input[type="radio"]');
      radio.addEventListener("change", (e) => {
        document.querySelectorAll(".shipping-rate-option.selected").forEach(el => el.classList.remove("selected"));
        option.classList.add("selected");

        const selectedPrice = parseFloat(e.target.dataset.price);
        if (!isNaN(selectedPrice)) {
          sessionStorage.setItem("selectedShippingRate", selectedPrice);
        }

        sessionStorage.setItem("selectedShippingOption", rate.label);

        ignoreNextCartUpdate = true;
        window.dispatchEvent(new Event("quoteCartUpdated"));

        // TODO submit quote should be disabled
        const submitButton = document.getElementById("submit-quote");
        if (submitButton) {
          submitButton.classList.add("submit-quote-active");
          submitButton.removeAttribute("disabled");
        }
      });

      container.appendChild(option);
    });
    //outside of rates.foreach
    document.getElementById("quote-clear-container").classList.remove("hidden");
    document.getElementById("quote-submit-container").classList.remove("hidden");
    document.getElementById("quote-shipping-button").classList.add("hidden");
  }

  // Reset shipping rates
  function resetShippingRates() {
    shippingRatesVisible = false;
    sessionStorage.removeItem("selectedShippingRate");
    localStorage.removeItem("quoteTax");


    const container = document.getElementById("shipping-methods-container");
    const warning = document.getElementById('shipping-warning');
    const clearContainer = document.getElementById("quote-clear-container");
    const submitContainer = document.getElementById("quote-submit-container");
    const shippingBtn =  document.getElementById("quote-shipping-button");

    if (container) {
      container.classList.add('hidden');
      container.innerHTML = "";
    }
    if (warning) {
      warning.classList.remove("hidden");
    }
    if (clearContainer) {
      clearContainer.classList.add("hidden");
    }
    if (submitContainer) {
      submitContainer.classList.add("hidden");
    }
    if (shippingBtn) {
      shippingBtn.classList.remove("hidden");
    }

    window.dispatchEvent(new Event("quoteCartUpdated"));
    setupShippingButtonValidation();
  }

  function getCurrentAddressState() {
    return {
      address: document.getElementById("quote-address")?.value,
      city: document.getElementById("quote-city")?.value,
      state: document.getElementById("quote-state")?.value,
      zip: document.getElementById("quote-zip")?.value,
      suite: document.getElementById("quote-suite-number")?.value,
      country: document.getElementById("country-select")?.value,
    };
  }

  window.addEventListener("load", () => {
    const requiredSelectors = [
      '#quote-email',
      '#quote-first-name',
      '#quote-last-name',
      '#quote-procurement-status',
      '#country-select',
      '#quote-address',
      '#quote-city',
      '#quote-state',
      '#quote-zip',
      '#quote-company'
    ];
    const requiredFields = document.querySelectorAll(requiredSelectors.join(", "));

    if (!requiredFields.length) return;

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        field.classList.add("initial-pulse");
      }
    });

    setTimeout(() => {
      requiredFields.forEach(field => field.classList.remove("initial-pulse"));
    }, 2500);

    const formContainer = document.querySelector(".quote-customer");
    let liveHighlightEnabled = false;

    formContainer.addEventListener("focusin", () => {
      if (liveHighlightEnabled) return;
      liveHighlightEnabled = true;

      requiredFields.forEach(field => {

        toggleFieldHighlight(field);

        field.addEventListener("input", () => toggleFieldHighlight(field));
        field.addEventListener("focus", () => field.classList.remove("highlight-required"));
        field.addEventListener("blur", () => toggleFieldHighlight(field));
      });
    }, { once: true });

    // Add clear address button functionality
    const clearAddressBtn = document.getElementById("clear-address-btn");
    if (clearAddressBtn) {
      clearAddressBtn.addEventListener("click", () => {
        // Clear all address fields (same as country change)
        document.getElementById("quote-address").value = "";
        document.getElementById("quote-city").value = "";
        document.getElementById("quote-state").value = "";
        document.getElementById("quote-zip").value = "";
        document.getElementById("quote-suite-number").value = "";
        
        // Reset country to default
        const countrySelect = document.getElementById("country-select");
        if (countrySelect) {
          countrySelect.selectedIndex = 0; // Select the placeholder option
        }

        // Call the same function as country change
        handleAddressOrContactChange({ resetAddressFields: false });
        
        console.log("Address fields cleared via CLEAR ADDRESS button");
      });
    }

    const emailInput = document.getElementById("quote-email");
    const firstNameInput = document.getElementById("quote-first-name");
    const marketingCheckbox = document.getElementById("quote-email-marketing");
    let customerStartTimer = null;

    const runCustomerStartSync = () => {
      startQuoteCustomerEmailSync().catch(error => {
        console.error("Quote customer start sync failed:", error);
      });
    };

    const queueCustomerStartSync = () => {
      clearTimeout(customerStartTimer);
      customerStartTimer = setTimeout(runCustomerStartSync, 500);
    };

    if (emailInput) {
      emailInput.addEventListener("input", () => {
        const normalizedEmail = normalizeQuoteEmail(emailInput.value);
        const storedRecord = getStoredQuoteCustomerRecord();

        if (storedRecord.email && storedRecord.email !== normalizedEmail) {
          setStoredQuoteCustomerRecord({});
        }
      });
    }

    if (firstNameInput) {
      firstNameInput.addEventListener("input", queueCustomerStartSync);
      firstNameInput.addEventListener("blur", () => {
        clearTimeout(customerStartTimer);
        runCustomerStartSync();
      });
    }

    if (marketingCheckbox) {
      marketingCheckbox.addEventListener("change", () => {
        const storedRecord = getStoredQuoteCustomerRecord();
        if (!storedRecord.customerId) return;

        syncQuoteCustomerMarketing().catch(error => {
          console.error("Quote customer marketing sync failed:", error);
        });
      });
    }
  });

  function toggleFieldHighlight(field) {
    if (field.value.trim()) {
      field.classList.remove("highlight-required");
    } else {
      field.classList.add("highlight-required");
    }
  }

  function attachSubmitQuoteListener() {
    const submitBtn = document.getElementById("submit-quote");
    if (!submitBtn) {
      console.warn("#submit-quote not found yet.");
      return;
    }

    if (submitBtn.dataset.listenerAttached) {
      console.log("Submit listener already attached, skipping.");
      return;
    }

    submitBtn.addEventListener("click", async () => {
      if (submitBtn.disabled || submitBtn.dataset.submitting) return;

      console.log("Submit Quote button clicked!");

      const quoteData = prepareQuoteData();
      if (!quoteData) {
        console.error("No quote data available");
        return;
      }

      // ponytail: lock before enrichment so repeated clicks cannot queue duplicate quote requests.
      submitBtn.dataset.submitting = "true";
      disableFormInteractions();

      try {
        console.log("Quote data prepared, sending...");
        try {
          await enrichQuoteCustomer();
        } catch (error) {
          console.error("Quote customer enrich failed:", error);
        }
        await sendQuoteData(quoteData);
        submitBtn.innerHTML = "Quote Submitted";
        window.dispatchEvent(new Event("quoteSubmittedSuccessfully"));
        trackGoogleAdsConversion();
      } catch (error) {
        console.error("Error:", error);
        delete submitBtn.dataset.submitting;
        enableFormInteractions();
      }
    });

    submitBtn.dataset.listenerAttached = "true";
  }

  const originalRenderShippingRates = renderShippingRates;
  renderShippingRates = function (rates) {
    originalRenderShippingRates(rates);

    setTimeout(() => {
      attachSubmitQuoteListener();
    }, 100);
  };

  function prepareQuoteData() {
    const quoteCart = sessionStorage.getItem("quoteCart" || '[]');
    if (!quoteCart) {
      console.error("No products found in sessionStorage.quoteCart");
      return null;
    }
    const parsedProducts = JSON.parse(quoteCart);

    // Shipping info
    const selectedShippingOption = sessionStorage.getItem("selectedShippingOption") || null;
    const selectedShippingRate = parseFloat(sessionStorage.getItem("selectedShippingRate") || "0");

    // Taxes
    let taxAmount = 0;
    const quoteTax = localStorage.getItem("quoteTax");
    if (quoteTax) {
      try {
        const taxData = JSON.parse(quoteTax);
        taxAmount = parseFloat(taxData.amount || "0");
      } catch (e) {
        console.error("Failed to parse quoteTax", e);
      }
    }

    const storedCustomerInfo = JSON.parse(sessionStorage.getItem("quoteCustomerInfo") || "{}");
    const publicNotes = sessionStorage.getItem("quoteNotes") || "";
    const productTypes = collectProductTypes(parsedProducts);

    const lineItems = parsedProducts.map(product => {

      const productId = product.product_id ? Number(product.product_id) : null;
      const variantId = product.variant_id ? Number(product.variant_id) : null;

      const priceNumber = product.price / 100;

      const fullImage = product.image?.startsWith("//")
        ? `https:${product.image}`
        : product.image;

      return {
        quantity: product.quantity,
        title: product.product_title,
        price: priceNumber,
        original_line_price: priceNumber,
        product_id: productId,
        variant_id: variantId,
        sku: product.sku,
        product_type: normalizeProductType(product.product_type),
        custom_product: false,
        image: fullImage,
        variant_title: product.variant_name || "",

        id: null,
        barcode: product.sku || null,
        custom_image_path: null,
        discount_amount: null,
        discount_reason: null,
        discount_total: null,
        discount_type: null,
        grams: null,
        item_properties: [],
        requires_shipping: true,
        taxable: true,
        url: null,
        total: priceNumber
      };
    });

    const subtotal = parsedProducts.reduce((sum, p) => sum + (p.price / 100) * p.quantity, 0);
    const total = subtotal + selectedShippingRate + taxAmount;

    // Get GCLID and MSClickID
    const gclid = getGclidFromLocalStorage();
    const msClickId = localStorage.getItem("MSClickID") || "";
    const attributionContext = getStoredAttributionContext();

    const leadAttribution = getLeadAttribution();
    const leadSource = leadAttribution.source || attributionContext.utmSource || 'direct';
    const leadMedium = leadAttribution.medium || attributionContext.utmMedium || 'none';
    const allCollections = new Set(
      parsedProducts.flatMap(product => normalizeCollectionHandles(product.collections))
    );

      console.log("allCollections:", [...allCollections]);

      const matchedTargets = [...TARGET_COLLECTION_HANDLES].filter(h => allCollections.has(h));
      const belongsToAnyTarget = matchedTargets.length > 0;

      console.log({ matchedTargets, belongsToAnyTarget });

      const hasBaseOrVariant = [...allCollections].some(
        h => h === TARGET_BASE_PREFIX || h.startsWith(`${TARGET_BASE_PREFIX}-`)
      );

      console.log({ hasBaseOrVariant });

      const belongsToTargetCollection = belongsToAnyTarget || hasBaseOrVariant;

      const assigneeId = belongsToTargetCollection ? 560 : 559;

    const quoteData = {
      email: storedCustomerInfo.email || "",
      first_name: storedCustomerInfo.firstName || "",
      last_name: storedCustomerInfo.lastName || "",
      remarks: publicNotes,
      internal_notes: "",
      public_notes: leadSource || '',
      tags: leadMedium || '',
      customer_id: null,
      phone: null,
      subtotal: subtotal.toFixed(2),
      total_tax: taxAmount.toFixed(2),
      total: total.toFixed(2),

      assignee_id: assigneeId,

      custom_fields: [
        { id: 9040, name: "Gclid", value: gclid },
        { id: 9478, name: "MsClickID", value: msClickId },
        { id: 9710, name: "wcClientCurrent", value: attributionContext.wcClientCurrent },
        { id: 9711, name: "landingUrl", value: attributionContext.landingUrl },
        { id: 9712, name: "currentPageUrl", value: attributionContext.currentPageUrl },
        { id: 9713, name: "utmSource", value: attributionContext.utmSource },
        { id: 9714, name: "utmMedium", value: attributionContext.utmMedium },
        { id: 9715, name: "utmCampaign", value: attributionContext.utmCampaign },
        { id: 9716, name: "utmContent", value: attributionContext.utmContent },
        { id: 9717, name: "utmTerm", value: attributionContext.utmTerm },
        { id: 6528, name: "Company", value: storedCustomerInfo.company || "" },
        { id: 9633, name: "Procurement Status", value: storedCustomerInfo.procurementStatus || "" },
        { id: 9702, name: "Product Type", value: productTypes.join(", ") },
        { id: 9320, name: "Shipping", value: selectedShippingRate.toFixed(2) },
        { id: 9321, name: "Tax", value: taxAmount.toFixed(2) },
        { id: 9322, name: "Shipping Option", value: selectedShippingOption || "" },
        { id: 9328, name: "Address", value: storedCustomerInfo.address || "" },
        { id: 9329, name: "Zip", value: storedCustomerInfo.zip || "" },
        { id: 9330, name: "City", value: storedCustomerInfo.city || "" },
        { id: 9331, name: "State", value: storedCustomerInfo.state || "" },
        { id: 9332, name: "Country", value: storedCustomerInfo.country || "" }
      ],

      line_items: lineItems
    };

    console.log("Prepared Quote Data for API:", quoteData);
    return quoteData;
  }

  // Function to get the gclid value from localStorage
  function getGclidFromLocalStorage() {
    const gclData = localStorage.getItem('_gcl_ls');

    if (gclData) {
      const parsedData = JSON.parse(gclData);
      return parsedData?.gclid?.value?.value || null;
    }
    return null;
  }

  function getCookieValue(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  }

  function getQueryParam(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function storeIfPresent(storageKey, value) {
    if (value) {
      localStorage.setItem(storageKey, value);
    }
  }

  function initializeAttributionContext() {
    const currentPageUrl = window.location.href;
    const existingLandingUrl = localStorage.getItem("landingUrl");

    storeIfPresent("currentPageUrl", currentPageUrl);

    if (!existingLandingUrl) {
      storeIfPresent("landingUrl", currentPageUrl);
    }

    storeIfPresent("utmSource", getQueryParam("utm_source"));
    storeIfPresent("utmMedium", getQueryParam("utm_medium"));
    storeIfPresent("utmCampaign", getQueryParam("utm_campaign"));
    storeIfPresent("utmContent", getQueryParam("utm_content"));
    storeIfPresent("utmTerm", getQueryParam("utm_term"));
    storeIfPresent("MSClickID", getQueryParam("msclkid"));
    storeIfPresent("wcClientCurrent", getCookieValue("wc_client_current"));
  }

  function getStoredAttributionContext() {
    initializeAttributionContext();

    return {
      wcClientCurrent: localStorage.getItem("wcClientCurrent") || "",
      landingUrl: localStorage.getItem("landingUrl") || "",
      currentPageUrl: window.location.href,
      utmSource: localStorage.getItem("utmSource") || "",
      utmMedium: localStorage.getItem("utmMedium") || "",
      utmCampaign: localStorage.getItem("utmCampaign") || "",
      utmContent: localStorage.getItem("utmContent") || "",
      utmTerm: localStorage.getItem("utmTerm") || ""
    };
  }

  function getLeadAttribution() {
    try {
      const stored = localStorage.getItem('LeadAttribution');
      if (stored) {
        const parsed = JSON.parse(stored);
        return {
          source: parsed?.source || '',
          medium: parsed?.medium || ''
        };
      }
    } catch (error) {
      console.error('Failed to parse LeadAttribution from localStorage:', error);
    }

    return {
      source: '',
      medium: ''
    };
  }

  // Store Gclid in localStorage if found
  const gclid = getGclidFromLocalStorage();

  if (gclid) {
    localStorage.setItem('gclid', gclid); // Store Gclid separately for easy access
  }

  // Set the Gclid in the hidden input field when the form loads
  document.addEventListener("DOMContentLoaded", function () {
    initializeAttributionContext();

    const storedGclid = localStorage.getItem('gclid');
    const gclidInput = document.getElementById('gclid-input');

    if (gclidInput && storedGclid) {
      gclidInput.value = storedGclid; // Set the value of the hidden input
    }

    // Debugging: Log the Gclid to ensure it's working
    console.log("Gclid Stored:", storedGclid);
    console.log("Hidden Input Value:", gclidInput ? gclidInput.value : "No input found");
    
    // Add event listener for keep shopping button
    const keepShoppingButton = document.getElementById('keep-shopping-button');
    if (keepShoppingButton) {
      keepShoppingButton.addEventListener('click', function(e) {
        console.log('🛍️ Keep Shopping button clicked - clearing all quote storage');
        clearQuoteStorage(false);
      });
    }
  });

  const uetmsclkidValue = getCookieValue('_uetmsclkid');

  if (uetmsclkidValue && !localStorage.getItem('MSClickID')) {
    localStorage.setItem('MSClickID', uetmsclkidValue);
  }

// ✅ Clears all session/localStorage data related to the quote
function clearQuoteStorage(preserveSubmittedCart = false) {
  sessionStorage.removeItem("quoteCart");
  sessionStorage.removeItem("selectedShippingRate");
  sessionStorage.removeItem("selectedShippingOption");
  sessionStorage.removeItem("quoteCustomerInfo");
  sessionStorage.removeItem(QUOTE_CUSTOMER_STORAGE_KEY);
  localStorage.removeItem("quoteTax");
  sessionStorage.removeItem("quoteNotes"); // Clear saved notes
  
  if (!preserveSubmittedCart) {
    sessionStorage.removeItem("submittedQuoteCart");
  }

  if (window.quoteCartManager) {
    window.quoteCartManager.cart = [];
    window.quoteCartManager.updateQuoteCartBadge();
  }
}

function belongsToAnalyticalServices(item) {
  const cols = normalizeCollectionHandles(item.collections);
  return cols
    .some(h =>
      TARGET_COLLECTION_HANDLES.has(h) ||
      h === TARGET_BASE_PREFIX ||
      h.startsWith(TARGET_BASE_PREFIX + '-')
    );
}

async function syncQuoteCartToShopifyCart() {
  const submittedCart = sessionStorage.getItem("submittedQuoteCart");
  const unsubmittedCart = sessionStorage.getItem("quoteCart");
  const cartData = submittedCart || unsubmittedCart;
  
  const cart = JSON.parse(cartData || "[]");
  if (!cart.length) {
    console.warn("No products in submittedQuoteCart or quoteCart to sync.");
    return;
  }

  // Filter out products with price 0.00, analytical services, and unavailable inventory
  const validProducts = cart.filter(item => {
    const price = Number(item.price);
    const zeroOrInvalidPrice = !Number.isFinite(price) || price <= 0;
    const isAnalyticalService = belongsToAnalyticalServices(item);
    const isAvailable = item.available;

    if (zeroOrInvalidPrice) {
      console.warn("Skipping product with $0/invalid price:", item.product_title);
      return false;
    }

    if (isAnalyticalService) {
      console.warn("Skipping analytical-services product:", item.product_title);
      return false;
    }

    if (!isAvailable) {
      console.warn("Skipping unavailable product (out of stock & no continue selling):", item.product_title);
      return false;
    }

    return true;
  });

  if (!validProducts.length) {
    console.warn("No valid priced products to sync.");
    
    const addToCartBtn = document.getElementById('add-all-to-cart');
    if (addToCartBtn) {
      addToCartBtn.style.display = 'none';
    }
    return { success: false, message: "No valid products to add to cart" };
  }

  // Clear current Shopify cart
  await fetch("/cart/clear.js", { method: "POST" });

  const itemsToAdd = validProducts.map(item => ({
    id: item.variant_id,
    quantity: item.quantity
  }));

  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: itemsToAdd })
  })
    .then(res => res.json())
    .then(data => ({ success: true, data }));
}

function disableFormInteractions() {
  document.querySelectorAll('.quote-cart-qty, .quote-qty-increment, .quote-qty-decrement, .remove-quote-item').forEach(element => {
    element.disabled = true;
    element.style.pointerEvents = 'none';
    element.style.opacity = '0.5';
  });
  
  document.querySelectorAll('input[name="shipping_rate"], #quote-shipping-button, #clear-address-btn').forEach(element => {
    element.disabled = true;
    element.style.pointerEvents = 'none';
    element.style.opacity = '0.5';
  });
  
  document.querySelectorAll('#quote-email, #quote-first-name, #quote-last-name, #quote-company, #quote-procurement-status, #quote-address, #quote-city, #quote-state, #quote-zip, #quote-suite-number, #country-select').forEach(element => {
    element.disabled = true;
    element.style.pointerEvents = 'none';
    element.style.opacity = '0.5';
  });

  const marketingCheckbox = document.getElementById('quote-email-marketing');
  if (marketingCheckbox) {
    marketingCheckbox.disabled = true;
  }
  
  const notesTextarea = document.getElementById('quote-notes');
  if (notesTextarea) {
    notesTextarea.disabled = true;
    notesTextarea.style.pointerEvents = 'none';
    notesTextarea.style.opacity = '0.5';
  }

  const submitBtn = document.getElementById("submit-quote");
  // Disable button & show loader
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.setAttribute("aria-disabled", "true");
    submitBtn.classList.add("loading");
    submitBtn.innerHTML = `
      <span class="loader-spinner"></span>
      <span class="loading-text">Generating Quote...</span>
    `;
  }
}

function enableFormInteractions() {
  document.querySelectorAll('.quote-cart-qty, .quote-qty-increment, .quote-qty-decrement, .remove-quote-item').forEach(element => {
    element.disabled = false;
    element.style.pointerEvents = 'auto';
    element.style.opacity = '1';
  });
  
  document.querySelectorAll('input[name="shipping_rate"], #quote-shipping-button, #clear-address-btn').forEach(element => {
    element.disabled = false;
    element.style.pointerEvents = 'auto';
    element.style.opacity = '1';
  });
  
  document.querySelectorAll('#quote-email, #quote-first-name, #quote-last-name, #quote-company, #quote-address, #quote-city, #quote-state, #quote-zip, #quote-suite-number, #country-select').forEach(element => {
    element.disabled = false;
    element.style.pointerEvents = 'auto';
    element.style.opacity = '1';
  });

  const marketingCheckbox = document.getElementById('quote-email-marketing');
  if (marketingCheckbox) {
    marketingCheckbox.disabled = false;
  }
  
  const notesTextarea = document.getElementById('quote-notes');
  if (notesTextarea) {
    notesTextarea.disabled = false;
    notesTextarea.style.pointerEvents = 'auto';
    notesTextarea.style.opacity = '1';
  }
  const submitBtn = document.getElementById("submit-quote");
  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.setAttribute("aria-disabled", "false");
    submitBtn.classList.remove("loading");
    submitBtn.innerHTML = "Submit Quote";
  }
}

function sendQuoteData(quoteData) {
  return fetch("https://requestquote.w3apps.co/api/v1/quotes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "msesupplies:f89b1f5b-89c5-4d85-be72-39ac34c19d14"
    },
    body: JSON.stringify(quoteData)
  })
    .then(response => {
      if (!response.ok) throw new Error("Failed to send quote");
      console.log("Quote request sent successfully");
      return response.json();
    })
    .then(data => {
      console.log("API Response:", data);
      const quotesNumber = data.id;

      const emailsFetchData = {
        quote_id: quotesNumber,
        include_link: false,
        include_pdf: true,
        email_assignee: true
      };

      console.log("Sending email request:", emailsFetchData);

      return fetch("https://requestquote.w3apps.co/api/v1/quotes/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "msesupplies:f89b1f5b-89c5-4d85-be72-39ac34c19d14"
        },
        body: JSON.stringify(emailsFetchData)
      });
    })
    .then(emailResponse => {
      if (emailResponse.ok) {
        console.log("✅ Email sent successfully");
      } else {
        console.error("❌ Failed to send email");
      }
    })
    .catch(error => {
      console.error("Error:", error);
      throw error;
    });
}

function trackGoogleAdsConversion() {
  if (typeof gtag === 'undefined') {
    console.error("❌ gtag is not defined! Google Ads script may not be loaded.");
    return;
  }  
  try {
    gtag('event', 'conversion', {
      'send_to': 'AW-930952831/FcIzCN-LhsQZEP_s9LsD',
      'value': 1.0,
      'currency': 'USD'
    });
    console.log("✅ Google Ads conversion tracked");
  } catch (error) {
    console.error("❌ Failed to fire conversion event:", error);
  }
}

window.addEventListener("quoteSubmittedSuccessfully", () => {
  const marketingCheckbox = document.getElementById("quote-email-marketing");
  if (marketingCheckbox) {
    marketingCheckbox.disabled = true;
  }
});

// Expose functions globally for use by other scripts
window.initAutocomplete = initAutocomplete;
window.syncQuoteCartToShopifyCart = syncQuoteCartToShopifyCart;
window.clearQuoteStorage = clearQuoteStorage;

window.addEventListener("quoteCartQuantityChanged", () => {
  if (shippingRatesVisible) {
    resetShippingRates();
  }
  
  // Check if cart is empty and handle UI accordingly
  const quoteCart = sessionStorage.getItem("quoteCart");
  let isEmpty = true;
  
  try {
    const parsedCart = JSON.parse(quoteCart);
    isEmpty = !quoteCart || !Array.isArray(parsedCart) || parsedCart.length === 0;
  } catch (e) {
    console.error("Failed to parse quoteCart from sessionStorage:", e);
    isEmpty = true;
  }
  
  const emptyContainer = document.getElementById('quote-cart-empty-container');
  const quoteHeader = document.querySelector('.quote-header');
  const quoteBody = document.getElementById('quote-page');
  const disclaimerDivider = document.querySelector('.quote-disclaimer-divider');
  const disclaimer = document.querySelector('.quote-disclaimer');
  
  if (isEmpty) {
    if (emptyContainer) {
      emptyContainer.style.display = 'block';
      emptyContainer.classList.remove('hidden');
    }
    if (quoteHeader) {
      quoteHeader.style.display = 'none';
    }
    if (quoteBody) {
      quoteBody.style.display = 'none';
      quoteBody.classList.add('hidden');
    }
    
    if (disclaimerDivider) {
      disclaimerDivider.style.display = 'none';
    }
    if (disclaimer) {
      disclaimer.style.display = 'none';
    }
  } else {
    if (emptyContainer) {
      emptyContainer.style.display = 'none';
      emptyContainer.classList.add('hidden');
    }
    if (quoteHeader) {
      quoteHeader.style.display = 'flex';
    }
    if (quoteBody) {
      quoteBody.style.display = 'block';
      quoteBody.classList.remove('hidden');
    }
    if (disclaimerDivider) {
      disclaimerDivider.style.display = 'block';
    }
    if (disclaimer) {
      disclaimer.style.display = 'block';
    }
  }
});
